/**
 * Copyright 2025 Paion Data. All rights reserved.
 */
import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import beijing from "../../assets/img/beijing.png";
import guilin from "../../assets/img/guilin.png";
import shenZhen from "../../assets/img/shenzhen.png";
import xian from "../../assets/img/xian.png";
import xiamen from "../../assets/img/xiamen.png";
import changsha from "../../assets/img/changsha.png";
import suzhou from "../../assets/img/suzhou.png";
import chongQing from "../../assets/img/chongqing.png";
import "animate.css";
import TrackVisibility from "react-on-screen";
import ProjectCard from "./ProjectCard";

import "./Projects.css";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import client1 from "../../assets/img/client1.png";
import client2 from "../../assets/img/client2.png";
import client3 from "../../assets/img/client3.png";
import client4 from "../../assets/img/client4.png";
import client5 from "../../assets/img/client5.png";
import client6 from "../../assets/img/client6.png";
import client7 from "../../assets/img/client7.png";
import client8 from "../../assets/img/client8.png";
import client9 from "../../assets/img/client9.png";
import client10 from "../../assets/img/client10.png";

import { useState } from "react";
import { ArrowLeft, ArrowRight } from "react-bootstrap-icons";
import { StyledItem } from "./styled";

export default function Projects(): JSX.Element {
  const { t } = useTranslation();

  const [activeIdx, setActiveIdx] = useState<number>(0);

  const clientImages = [client1, client2, client3, client4, client5, client6, client7, client8, client9, client10];

  const projects = [
    {
      title: t("Shenzhen"),
      description: t("Technology"),
      imgUrl: shenZhen,
      route: "/shenzhen",
    },
    {
      title: t("Chongqing"),
      description: t("Culture & Religion"),
      imgUrl: chongQing,
      route: "/chongqing",
    },
    {
      title: t("Beijing"),
      description: t("Culture & Food"),
      imgUrl: beijing,
      route: "/beijing",
    },
    {
      title: t("Guilin"),
      description: t("Living in Guangxi"),
      imgUrl: guilin,
      route: "/guilin",
    },
    {
      title: t("Xi'an"),
      description: t("Economic Views"),
      imgUrl: xian,
      route: "/xian",
    },
    {
      title: t("Suzhou"),
      description: t("Culture & Food"),
      imgUrl: suzhou,
      route: "/suzhou",
    },
    {
      title: t("Xiamen"),
      description: t("Culture & Food"),
      imgUrl: xiamen,
      route: "/xiamen",
    },
    {
      title: t("Suzhou"),
      description: t("Culture & Food"),
      imgUrl: changsha,
      route: "/changsha",
    },
  ];

  const getTransform = (imageIdx: number): string => {
    if (imageIdx < activeIdx) {
      const distance = activeIdx - imageIdx;
      return `translateX(${-220 * distance}px) scale(${1 - 0.2 * distance}) perspective(16px) rotateY(1deg)`;
    }

    if (imageIdx === activeIdx) {
      return "none";
    }

    if (imageIdx > activeIdx) {
      const distance = imageIdx - activeIdx;
      return `translateX(${220 * distance}px) scale(${1 - 0.2 * distance}) perspective(16px) rotateY(-1deg)`;
    }
  };

  return (
    <section className="project" id="projects">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) => (
                <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                  <h2>{t("Touring Projects")}</h2>
                  <p>{t("Projects campaign message")}</p>
                  <Tab.Container id="projects-tabs" defaultActiveKey="first">
                    <Nav
                      variant="pills"
                      className="nav-pills mb-5 justify-content-center align-items-center"
                      id="pills-tab"
                    >
                      <Nav.Item>
                        <Nav.Link eventKey="first">{t("Locations")}</Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="second">{t("Our Clients")}</Nav.Link>
                      </Nav.Item>
                    </Nav>
                    <Tab.Content id="slideInUp" className={isVisible ? "animate__animated animate__slideInUp" : ""}>
                      <Tab.Pane eventKey="first">
                        <Row>
                          {projects.map((project, index) => {
                            return (
                              <Col size={12} sm={6} md={4} lg={3} key={project.title}>
                                <Link to={project.route} className="tour-route-link">
                                  <ProjectCard key={index} {...project} />
                                </Link>
                              </Col>
                            );
                          })}
                        </Row>
                      </Tab.Pane>
                      <Tab.Pane eventKey="second">
                        <div className="slider">
                          {clientImages.map((clientImage, idx) => {
                            return (
                              <StyledItem
                                key={`client-${idx}`}
                                $transform={getTransform(idx)}
                                $zIndex={idx === activeIdx ? 1 + 100 : -Math.abs(activeIdx - idx) + 100}
                                $filter={idx === activeIdx ? "none" : "blur(5px)"}
                                $opacity={idx === activeIdx ? 1 : Math.abs(activeIdx - idx) > 2 ? 0 : 0.6}
                              >
                                <img src={clientImage} />
                              </StyledItem>
                            );
                          })}
                          <button
                            className="gallery-button"
                            type="button"
                            id="next"
                            onClick={() => {
                              setActiveIdx(activeIdx < clientImages.length - 1 ? activeIdx + 1 : activeIdx);
                            }}
                          >
                            <ArrowRight />
                          </button>
                          <button
                            className="gallery-button"
                            type="button"
                            id="prev"
                            onClick={() => {
                              setActiveIdx(activeIdx >= 1 ? activeIdx - 1 : activeIdx);
                            }}
                          >
                            <ArrowLeft />
                          </button>
                        </div>
                      </Tab.Pane>
                    </Tab.Content>
                  </Tab.Container>
                </div>
              )}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  );
}
